export default __webpack_public_path__ + "static/blob7-fbf44d5780b3f6020128cf01b5796c1b.svg";